import { getTokenJWT } from "../../utils";
import ErrorToast from "../../../components/errortoast/ErrorToast";

const addEM = {
  //Upload image to media library
  async addImage(data, imgData) {
    let imageId;
    let formData = new FormData();
    formData.append("files", imgData);

    const requestOptions = {
      method: "POST",
      headers: {
        "Authorization": getTokenJWT(),
      },
      body: formData,
      redirect: "follow",
    };

    let newData;
    try {
      const response = await fetch(`${window.$apiUrl}/upload`, requestOptions);
      const res = await response.json();

      imageId = res[0]._id;
      newData = await this.addEM(data, imageId).then((result) => {
        return result;
      });
    } catch(error) {
      console.error(" Error adding event -->", error)
    }

    return newData;
  },

  //Post content to database
  addEM(data, imageId) {
    //Headers
    let headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    headers.append("Authorization", getTokenJWT())

    //Body
    let urlencoded = new URLSearchParams();
    urlencoded.append("rowId", JSON.stringify(data.tableData));
    urlencoded.append("startDate", data.startDate);
    urlencoded.append("endDate", data.endDate);
    urlencoded.append("eventName", data.eventName);
    urlencoded.append("objective", data.objective);
    urlencoded.append("reachedAudience", data.reachedAudience);
    urlencoded.append("link", data.link);
    urlencoded.append("photo", imageId);

    for (let i = 0; i < data.eventType.length; i++) {
      urlencoded.append("eventType", data.eventType[i]);
    }

    for (let i = 0; i < data.partners.length; i++) {
      urlencoded.append("partners", data.partners[i]);
    }

    for (let j = 0; j < data.targetAudience.length; j++) {
      urlencoded.append("targetAudience", data.targetAudience[j]);
    }

    const requestOptions = {
      method: "POST",
      headers: headers,
      body: urlencoded,
      redirect: "follow",
    };

    return fetch(`${window.$apiUrl}/meetings`, requestOptions)
      .then((response) => {return response.json()})
      .then((result) => {
        if (result.statusCode && result.error) {
          console.error(" Error adding event -->", result);
          ErrorToast(result.error);
          return;
        } else return result;
      })
      .catch((error) => console.error(" Error adding event -->", error));
  },
};

export default addEM;
